"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayCustomize = void 0;
var react_1 = __importDefault(require("react"));
var Section_1 = require("../components/Section");
var variables = "$displays: (\n  b: block,\n  f: flex,\n  i: inline,\n  ib: inline-block,\n  if: inline-flex,\n);\n\n$opacity: (n: 10);\n\n$z: (n: 3, step: 10);";
var DisplayCustomize = function () { return (react_1.default.createElement(Section_1.Customize, { variables: variables })); };
exports.DisplayCustomize = DisplayCustomize;
